<app-overlay-loader *ngIf="showOverlayLoader"></app-overlay-loader>
<div class="launch-case-container">
  <!-- Header Section -->
  <header class="header">
    <div class="time-allocation">
      Maximum allotted real time: {{ maxAllottedTime }}
    </div>
    <div class="header-actions">
      <button (click)="onHelpClick()">Help</button>
      <button (click)="onAboutClick()">About</button>
      <button (click)="onEndCaseClick()">Endcase</button>
    </div>
  </header>

  <!-- Action Buttons Section -->
  <div class="action-buttons" *ngIf="!isCaseEndPhase">
    <button class="action-button" (click)="onIntervalClick()">
      <img src="assets/interval.png" alt="Interval">
      <span>Interval</span>
    </button>
    <button class="action-button" (click)="openOrders()">
      <img src="assets/orders.png" alt="Orders">
      <span>Orders</span>
    </button>
    <button class="action-button" (click)="onClockClick()">
      <img src="assets/clock.png" alt="Clock">
      <span>{{ formatCaseTime() }}</span>
    </button>
    <button class="action-button " (click)="openLocationDialog()">
      <img [src]="getLocationImage()" class="location" alt="Office Change Location">
      <span>Location: {{ currentLocation }}</span>
    </button>
  </div>

  <!-- Content Body -->
  <div class="content-body" [ngClass]="{'interval-container': showInterval}">
    <app-orders 
      *ngIf="showOrders" 
      [orderList]="orderList"
      [currentTime]="formatCaseTime()"
      [currentCaseDay]="currentCaseDay"
      [currentCaseTime]="currentCaseTime"
      [savedOrders]="getSavedOrders()"
      [vitalSignsHistory]="vitalSignsHistory"
      [progressNotes]="progressNotes"
      [selectedOrderIds]="selectedOrderIds"
      [cancelledOrders]="cancelledOrders"
      (ordersUpdated)="onOrdersUpdated($event)"
      (showVitalSigns)="onShowVitalSigns($event)"
      (showProgressNote)="onShowProgressNote($event)"
      (showOrderResult)="onShowOrderResult($event)"
      (orderCancelled)="onOrderCancelled($event)">
    </app-orders>
    <app-interval 
      [physicalExamOptions]="physicalEvaluations" 
      [physicalExamOptionsResponse]="evaluationsResponse" 
      [currentCaseDay]="currentCaseDay"
      [currentCaseTime]="currentCaseTime"
      (timeAdvance)="onIntervalTimeAdvance($event)"
      *ngIf="showInterval">
    </app-interval>
    <div class="placeholder" *ngIf="!showInterval">
      Select an option above
    </div>
  </div>

  <!-- Footer Section -->
  <footer class="footer">
    <div class="time-info">
      <div>Elapsed SIMULATED Time = {{ elapsedTime.days }} Days {{ elapsedTime.hours }} Hours {{ elapsedTime.minutes }} Minutes</div>
      <div>Remaining REAL Time = {{ remainingTime.minutes }} Mins {{ remainingTime.seconds }} Secs</div>
    </div>
  </footer>
</div>

<!-- Location Dialog -->
<app-location-dialog 
  *ngIf="showLocationDialog"
  [currentLocation]="currentLocation"
  [currentCaseTime]="formatCaseTime()"
  (locationSelected)="onLocationSelected($event)"
  (showOrdersDialog)="onShowOrdersDialog($event)"
  (closeDialog)="showLocationDialog = false">
</app-location-dialog>

<!-- Location Orders Dialog -->
<app-location-orders-dialog
  *ngIf="showLocationOrdersDialog"
  [selectedOrders]="selectedOrders"
  [newLocation]="pendingLocation"
  [currentCaseTime]="formatCaseTime()"
  [isOutpatientLocation]="isOutpatientLocation"
  [selectedSimulationTime]="selectedSimulationTime"
  (confirmMove)="onLocationOrdersConfirm($event)"
  (cancelMove)="onCancelLocationMove()"
  (openTimeSelection)="onOpenTimeSelection()"
  (closeDialog)="showLocationOrdersDialog = false">
</app-location-orders-dialog>

<!-- Vitals Dialog -->
<app-info-dialog
  [isVisible]="showVitalsDialog"
  [title]="'Baseline Vitals'"
  [content]="vitalContent"
  (close)="onVitalsDialogClose()">
</app-info-dialog>

<app-info-dialog
  [isVisible]="showIntroductionDialog"
  [title]="'Introduction'"
  [content]="caseData.Introduction"
  (close)="onIntroductionDialogClose()">
</app-info-dialog>

<app-info-dialog
  [isVisible]="showHistoryDialog"
  [title]="'History of Present Illness'"
  [content]="caseData.past_medical_history"
  (close)="onHistoryDialogClose()">
</app-info-dialog>

<app-info-dialog
  [isVisible]="showVitalsDialog"
  [title]="'Baseline Vitals'"
  [content]="vitalContent"
  (close)="onVitalsDialogClose()">
</app-info-dialog> 


<!-- Add this at the bottom of the file, near other dialogs -->
 <div   *ngIf="showClockDialog">
  <div class="clock-dialog-overlay">
    <div class="clock-dialog">
      <div class="dialog-header">
        <h2>Time Simulation</h2>
        <button class="close-button" (click)="onClose()">×</button>
      </div>
      <div class="dialog-content">
        <div class="container-layout">
          <!-- Left Container - Calendar -->
          <div class="left-container">
            <div class="calendar">
              <b>Calendar</b>
              <div class="actual-calendar">
                <table class="mytableclass table-striped">
                  <thead>
                    <tr>
                      <th>Sun</th>
                      <th>Mon</th>
                      <th>Tue</th>
                      <th>Wed</th>
                      <th>Thu</th>
                      <th>Fri</th>
                      <th>Sat</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- [class.current-day]="currentCaseDay === day" -->
                    <tr *ngFor="let week of calendar; let i = index">
                      <td *ngFor="let day of week" 
                          [class.active-calendar]="selectedDay == day"
                          
                          [class.alternate-row]="i % 2 == 1"
                          (click)="onDayClick(day)">
                        {{ day > 0 ? day : '' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          
          <!-- Right Container -->
          <div class="right-container">
            <div class="case">
              <b>Reevaluate Case</b>
              <div class="actual-case">
                <div class="row">
                  <div class=" schedule">
                    <ul class="options-list">
                      <li>
                        <input type="radio" 
                               name="when" 
                               id="on" 
                               [value]="'on'" 
                               [checked]="selectedOption === 'on'"
                               (change)="onSimulationOptionChange('on')"> 
                        <label for="on">On</label>
                      </li>
                      <li>
                        <input type="radio" 
                               name="when" 
                               id="in" 
                               [value]="'in'"
                               [checked]="selectedOption === 'in'"
                               (change)="onSimulationOptionChange('in')"> 
                        <label for="in">In</label>
                      </li>
                      <li>
                        <input type="radio" 
                               name="when" 
                               id="nextresult" 
                               [value]="'nextresult'"
                               [checked]="selectedOption === 'nextresult'"
                               (change)="onSimulationOptionChange('nextresult')"> 
                        <label for="nextresult">With next available result</label>
                      </li>
                      <li>
                        <input type="radio" 
                               name="when" 
                               id="asneeded" 
                               [value]="'asneeded'"
                               [checked]="selectedOption === 'asneeded'"
                               (change)="onSimulationOptionChange('asneeded')"> 
                        <label for="asneeded">Call/See me as needed</label>
                      </li>
                    </ul>
                  </div>
                  <div class=" schedule" *ngIf="showTimeSpinners">
                    <div class="schedule-child">
                      <p class="spinner-label">Day(s) : Hour(s) : Minute(s)</p>
                      <div class="spinner-container">
                        <input type="number" 
                               [value]="simulationTime.days"
                               (input)="onDayChange($any($event.target).value)"
                               min="0"
                               max="999"
                               class="spinner-input">
                        <input type="number" 
                               [value]="simulationTime.hours"
                               (input)="onHourChange($any($event.target).value)"
                               min="0"
                               max="23"
                               class="spinner-input">
                        <input type="number" 
                               [value]="simulationTime.minutes"
                               (input)="onMinuteChange($any($event.target).value)"
                               min="0"
                               max="59"
                               class="spinner-input">
                      </div>
                      <div class="day-of-week">{{ currentDayOfWeek }}</div>
                    </div>
                  </div>
                </div>
                <!-- Add simulation buttons -->
                <div class="simulation-actions">
                  <button class="btn-simulate" (click)="onTimeSelected(simulationTime)">OK</button>
                  <button class="btn-cancel" (click)="onClose()">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
 </div>
<!-- <app-clock-dialog
  *ngIf="showClockDialog"
  (closeDialog)="onClockDialogClose()">
</app-clock-dialog> -->

<!-- Time Error Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showTimeError">
  <div class="confirmation-dialog">
    <div class="confirmation-content">
      <h3>Invalid Time Selection</h3>
      <p>The entered time has been passed. Please enter a new time.</p>
      <div class="confirmation-actions">
        <button class="btn-continue" (click)="closeTimeError()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- No Orders Available Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showNoOrdersDialog">
  <div class="confirmation-dialog">
    <div class="confirmation-content">
      <h3>No Orders Available</h3>
      <p>There are no upcoming orders with available results to advance to.</p>
      <div class="confirmation-actions">
        <button class="btn-continue" (click)="closeNoOrdersDialog()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Advance Confirmation Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showAdvanceConfirmation">
  <div class="confirmation-dialog">
    <div class="confirmation-content">
      <h3>Time Advance Confirmation</h3>
      <p>Current time is Day {{ currentCaseDay }} @ {{ currentCaseTime }}</p>
      <p>Continue clock advance?</p>
      <div class="confirmation-actions">
        <button class="btn-stop" (click)="onAdvanceConfirm(false)">Stop now</button>
        <button class="btn-continue" (click)="onAdvanceConfirm(true)">Continue</button>
      </div>
    </div>
  </div>
</div>

<!-- Patient Condition Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showConditionPopup">
  <div class="confirmation-dialog">
    <div class="confirmation-content">
      <h3>Patient Condition Update</h3>
      <p>{{ currentCondition }}</p>
      <div class="confirmation-actions">
        <button class="btn-continue" (click)="onConditionConfirm()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Order Response Dialog -->
<div class="dialog-overlay" *ngIf="showOrderResponsePopup">
  <div class="dialog-popup order-response">
    <div class="dialog-header">
      <h2>{{ currentOrderName }}</h2>
      <button class="close-button" (click)="onOrderResponseConfirm()">×</button>
    </div>
    <div class="dialog-content">
      <div [innerHTML]="currentOrderResponse"></div>
    </div>
  </div>
</div>

<!-- Time Expired Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showTimeExpiredDialog">
  <div class="confirmation-dialog">
    <div class="confirmation-content">
      <h3>Time Expired</h3>
      <p>Your allocated time for this case has finished.</p>
      <p>The case will now be concluded.</p>
      <div class="confirmation-actions">
        <button class="btn-continue" (click)="onTimeExpiredConfirm()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Case-End Instructions Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showCaseEndInstructions">
  <div class="confirmation-dialog case-end-dialog">
    <div class="confirmation-content">
      <h3>Case-end Instructions</h3>
      <div class="case-end-content">
        <p class="bold-text">This case will end in 2 minutes of "real time"</p>
        <p>On the next screens, finalize care of patient's "current" condition by</p>
        <p>-deleting orders you want cancelled now</p>
        <p>-adding orders to be done now.</p>
        <p>-adding orders relevant to the patient's "current" condition to be done in the future.</p>
        <p>Then, confirm orders and enter a diagnosis.</p>
      </div>
      <div class="confirmation-actions">
        <button class="btn-continue" (click)="onCaseEndInstructionsConfirm()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- End Case Confirmation Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showEndCaseConfirmation">
  <div class="confirmation-dialog">
    <div class="confirmation-content">
      <h3>Confirm Action</h3>
      <p>Are you sure you want to leave this case? Your progress will be lost.</p>
      <div class="confirmation-actions">
        <button class="btn-stop" (click)="onEndCaseCancel()">No</button>
        <button class="btn-continue" (click)="onEndCaseConfirm()">Yes</button>
      </div>
    </div>
  </div>
</div>